module.exports = __webpack_public_path__ + "img/analucila-ny-lapp.17963359.png";